import React, { useEffect } from "react";
import { motion, useAnimation, useScroll, useTransform } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";
import AnimatedSequence from "./vcnranimation";
import bgVideo from "../Assets/videos/homeloop.mp4";
import "./Banner.css";

const Banner = () => {
  const navigate = useNavigate();
  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0.2, triggerOnce: true });

  // Parallax effect on scroll
  const { scrollY } = useScroll();
  const yParallax = useTransform(scrollY, [0, 500], [0, 80]); // smooth scroll shift

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [inView, controls]);

  return (
    <section className="banner-section" ref={ref}>
      {/* Smooth fade-in background video */}
      <motion.div
        className="video-bg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
        <motion.video
          src={bgVideo}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className="bg-video"
          style={{ y: yParallax }}  // parallax movement on scroll
        />
      </motion.div>

      {/* Smooth Content Animation */}
      <motion.div
        className="banner-content"
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 1.2,
              ease: "easeOut",
              delay: 0.3,
            },
          },
        }}
        initial="hidden"
        animate={controls}
      >
        <AnimatedSequence />
        <h1>Scalable Growth. Enduring Value. Enriching Lives.</h1>
      </motion.div>
    </section>
  );
};

export default Banner;
